import axios from 'axios'
import qs from 'qs'

axios.interceptors.request.use(
  (config) => {
    if (config.method === 'post') {
      if (!(config.data instanceof FormData)) {
        config.data = qs.stringify(config.data)
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      }
    }
    return config
  }, 
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {    
    return response.data
  }, 
  (error) => {
    return Promise.reject(error);
  }
)


export default axios